import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import useAuthentication from "../hooks/useAuthentication";
import { getRedirectRouteWithFallback } from "../utility/utilityFunctions";

const GuestRoute = ({ children }) => {
  const { isLoggedIn, isLoggingIn, isInitializing } = useAuthentication();
  const location = useLocation();
  // Without this, a page refresh on a guest-only route (e.g. /login) would
  // render the actual login form for an already-authenticated user during
  // the window before the persisted-session check resolves.
  if (isInitializing || isLoggingIn) {
    return <CircularProgress size={20} />;
  }
  // Honor the page that sent the user here (state.from). This render runs
  // right after login, so redirecting to HOME unconditionally would override
  // the redirect back that the login page itself asks for.
  if (isLoggedIn) {
    return <Navigate to={getRedirectRouteWithFallback(location)} replace />;
  }
  return children;
};

export default GuestRoute;
